import { fabric } from 'fabric';

type clipPathObjectType = {
    path?: unknown[];
    type?: string;
    canvas?: unknown;
    ownMatrixCache?: unknown;
    cacheHeight?: unknown;
    cacheTranslationX?: unknown;
    cacheTranslationY?: unknown;
    editedProps?: unknown;
    excludeFromUpdateLock?: unknown;
    ownCaching?: unknown;
    cacheWidth?: unknown;
    _cacheContext?: unknown;
    _cacheProperties?: unknown;
    _transformDone?: unknown;
    _cacheCanvas?: unknown;
};

const resetUnusedProperties = (object: clipPathObjectType) => {
    // Properties that are not needed for the clipPath object
    const propertiesToReset: (keyof clipPathObjectType)[] = [
        'canvas',
        'ownMatrixCache',
        'cacheHeight',
        'cacheTranslationX',
        'cacheTranslationY',
        'editedProps',
        'excludeFromUpdateLock',
        'ownCaching',
        'cacheWidth',
        '_cacheContext',
        '_cacheProperties',
        '_transformDone',
        '_cacheCanvas'
    ];

    propertiesToReset.forEach((property) => {
        object[property] = undefined;
    });
};

export const loadClipPathFromObject = async (object: clipPathObjectType | fabric.Rect | fabric.Path) => {
    // If the object is already an instance of fabric.Rect or fabric.Path, return accordingly
    if (object instanceof fabric.Rect) {
        return object;
    }
    if (object instanceof fabric.Path) {
        return object.path && object.path.length > 0 ? object : undefined;
    }

    // If the object is a plain object, validate the path property and create a fabric.Path instance if valid
    if (object.path && object.path.length > 0) {
        resetUnusedProperties(object);
        return new Promise((resolve) => {
            fabric.Path.fromObject(object, (clipPath: fabric.Path) => {
                clipPath.set({
                    originX: 'center',
                    originY: 'center'
                });
                resolve(clipPath);
            });
        });
    }

    if (object.type === 'rect') {
        return fabric.Rect.fromObject(object);
    }

    return undefined;
};
